// extracted by mini-css-extract-plugin
export default {"calendar":"history_calendar__CUufR"};